import { render } from "./areaSpaline.vue?vue&type=template&id=51026f4b"
import script from "./areaSpaline.vue?vue&type=script&lang=js"
export * from "./areaSpaline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__